// Для работы модуля необходимо добавить служебный класс js-ajax-btn к ссылкам.
// Все страницы должны быть завернуты в блок с классом js-ajax-box.
// если у ссылки нет класса js-ajax-btn она сохранит обычную логику работы ссылки.
// ВНИМАНИЕ: при сиспользовании этого модуля для работы метрик(яндекс, гугл) необходимо использовать доп параметры
/* globals yaCounter39746420, ga */
itsoftApp.createModule("ajax", function() {
    var btnClass = ".js-ajax-btn";
    var btn = $(btnClass);
    var boxClass = (".js-ajax-box");
    var box = $(boxClass);

    if (!btn.length || !box.length) {
        return false;
    }

    DEBUG && console.log("[module ajaxLoad] init");

    var content = $(".js-ajax-content")
    var noindex = "content--noindex";
    var noajax = ("no-ajax");
    var animateClass = ("is-animate");
    var timeAttr = "data-timeout";

    var parentsUrl, parentsUrlOld;
    var $document = itsoftApp.commonVars.$document;
    var activeClass = "is-active";

     // Сохраняет переходы
    window.addEventListener("popstate", function() {
        DEBUG && console.log("[ajax] back")
        // Передаем текущий URL
        getContent(location.pathname, false);
    });

    //подготовка для переходов(анимация)
    function openHref(url){
        var time;

        box.removeClass(noajax);
        if (content.length){
            content.addClass(animateClass);
            time = content.attr(timeAttr);
        }
        else{
            time = 0;
        }

        setTimeout(function() {
            if (content.length){
                content.removeClass(noindex);
                if (!(url == "/")){
                    content.addClass(noindex);
                }
                else{
                    content.removeClass(noindex);
                }
            }

            getContent(url, true);
        }, time);
    }

    // Функция загрузки контента
    function getContent(url, addEntry) {
        $.get(url).done(function(data) {
            // Обработка пустого запроса
            if (!$(data).find(boxClass).html()){
                DEBUG && console.log("[ajax] empty request");
                return false;
            }

            // передаст только первое вхождение блока .js-ajax-box. Записывает содержимое блока
            box.html($(data).find(boxClass).html());
            $(".js-index").addClass(animateClass);
            // Инициализация модулей.
            itsoftApp.removeModule();
            itsoftApp.initNewModule();
            // Сохраниение истории переходов
            if(addEntry == true) {
                DEBUG && console.log("[ajax] pushState")
                history.pushState(null, null, url);
            }

            // анимация
            setTimeout(function() {
                content.removeClass(animateClass);},0);

            setTimeout(function() {
                $(".js-index").removeClass(animateClass);},250);


        })
    }

    //Обработка нажатия при переходе по ссылке
    btn.on("click", function(e){
        var self = $(this);
        var href = self.attr("href");

        DEBUG && console.log("[ajaxLoad] click")

        // отменяет стандартное действие
        e.preventDefault();

        openHref(href);

        $document.addClass(activeClass);
        parentsUrlOld = location.href;
        parentsUrl = self.attr("href");

        yaCounter39746420.hit(parentsUrl, {referer: parentsUrlOld }) ;
        ga("set", "page", parentsUrl);
        ga("send", "pageview");


    });

    // открытие контактов с главного экрана
    $(".js-button-next").on("click", function(){
        if(!$(this).hasClass("swiper-button-disabled")){
            return false
        }
        var href = $(this).attr("data-href");

        DEBUG && console.log("[ajaxLoad] contact open")

        openHref(href);

    });
});